module.exports = __webpack_public_path__ + "static/media/silver_ticket.c040f12f.jpg";